import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap gap-4"
}
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex pt-1.5" }
const _hoisted_4 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_5 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_6 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_7 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_8 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_9 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_10 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_11 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_12 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_13 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_14 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_15 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_16 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_17 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_18 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_19 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_20 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_21 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "text-2xl" }
const _hoisted_29 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_30 = {
  key: 0,
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_31 = {
  key: 1,
  style: {"overflow-y":"auto","height":"calc(100vh - 242px)"}
}
const _hoisted_32 = { class: "flex flex-wrap gap-4 p-4" }
const _hoisted_33 = { class: "flex flex-col justify-between" }
const _hoisted_34 = { class: "flex flex-col justify-between" }
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = { class: "flex pt-1.5" }
const _hoisted_37 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_38 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_39 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_40 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_41 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_42 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_43 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_44 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_45 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_46 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_47 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_48 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_49 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_50 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_51 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_52 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_53 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_54 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "text-2xl" }
const _hoisted_62 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_63 = {
  key: 0,
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "flex w-full flex-col md:flex-row md:justify-between mt-4"
}
const _hoisted_71 = { class: "md:ml-10" }
const _hoisted_72 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_73 = { class: "hidden md:flex items-center mb-4 mr-3" }
const _hoisted_74 = { class: "mr-5" }
const _hoisted_75 = { class: "md:hidden flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CarouselLoading = _resolveComponent("CarouselLoading")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ImgLoading = _resolveComponent("ImgLoading")!
  const _component_AlertStatusIndicators = _resolveComponent("AlertStatusIndicators")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_QuantityEditDrawer = _resolveComponent("QuantityEditDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "md:hidden",
      style: _normalizeStyle({'height': _ctx.isStandalone ? 'calc(100vh - 242px)' : 'auto'})
    }, [
      (!_ctx.isStandalone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!_ctx.isStandalone ? _ctx.tableData : _ctx.data), (item) => {
              return (_openBlock(), _createBlock(_component_el_card, {
                style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                key: item.inventory_id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      (item.check_result1 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                        : (item.check_result1 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                          : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                      (item.check_result2 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                        : (item.check_result2 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9)),
                      (item.check_result3 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                        : (item.check_result3 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12)),
                      (item.check_result4 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                        : (item.check_result4 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15)),
                      (item.check_result5 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : (item.check_result5 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                      (item.check_result6 === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                        : (item.check_result6 === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer",
                        onClick: ($event: any) => (_ctx.handleEditButton(item))
                      }, " edit_square ", 8, _hoisted_22),
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer ml-2",
                        onClick: ($event: any) => (_ctx.handleAlarmButton(item))
                      }, " alarm ", 8, _hoisted_23),
                      (_ctx.isAuthForTransfer.valueOf())
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "material-symbols-outlined cursor-pointer ml-2",
                            onClick: ($event: any) => (_ctx.handleTransferInventoryButton(item))
                          }, " trolley ", 8, _hoisted_24))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer ml-2",
                        onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                      }, " delete ", 8, _hoisted_25)
                    ])
                  ]),
                  _createVNode(_component_el_row, { align: "middle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 19 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", null, "保管日: " + _toDisplayString(_ctx.formatDate(item.storage_date!)), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'text-red-500': _ctx.isExpired(item.expiration_date) })
                            }, " 有効期限: " + _toDisplayString(_ctx.formatDate(item.expiration_date)), 3)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 5 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex justify-end items-baseline cursor-pointer",
                            onClick: ($event: any) => (_ctx.handleClickQuantityButton(item))
                          }, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(item.quantity), 1),
                            (item.material_unit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.material_unit), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_27)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (item.images)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_CarouselLoading, {
                          modelValue: item.images,
                          "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                          height: "160px"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!_ctx.isStandalone ? _ctx.tableData : _ctx.data), (item) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                  key: item.inventory_id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", null, _toDisplayString(item.organization_name), 1),
                      _createElementVNode("div", null, _toDisplayString(item.department_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                      _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        (item.check_result1 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37))
                          : (item.check_result1 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39)),
                        (item.check_result2 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                          : (item.check_result2 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                            : (_openBlock(), _createElementBlock("div", _hoisted_42)),
                        (item.check_result3 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                          : (item.check_result3 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45)),
                        (item.check_result4 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46))
                          : (item.check_result4 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                            : (_openBlock(), _createElementBlock("div", _hoisted_48)),
                        (item.check_result5 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49))
                          : (item.check_result5 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                            : (_openBlock(), _createElementBlock("div", _hoisted_51)),
                        (item.check_result6 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                          : (item.check_result6 === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53))
                            : (_openBlock(), _createElementBlock("div", _hoisted_54))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer",
                          onClick: ($event: any) => (_ctx.handleEditButton(item))
                        }, " edit_square ", 8, _hoisted_55),
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer ml-2",
                          onClick: ($event: any) => (_ctx.handleAlarmButton(item))
                        }, " alarm ", 8, _hoisted_56),
                        (_ctx.isAuthForTransfer.valueOf())
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "material-symbols-outlined cursor-pointer ml-2",
                              onClick: ($event: any) => (_ctx.handleTransferInventoryButton(item))
                            }, " trolley ", 8, _hoisted_57))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer ml-2",
                          onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                        }, " delete ", 8, _hoisted_58)
                      ])
                    ]),
                    _createVNode(_component_el_row, { align: "middle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 19 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", null, "保管日: " + _toDisplayString(_ctx.formatDate(item.storage_date!)), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass({ 'text-red-500': _ctx.isExpired(item.expiration_date) })
                              }, " 有効期限: " + _toDisplayString(_ctx.formatDate(item.expiration_date)), 3)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 5 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "flex justify-end items-baseline cursor-pointer",
                              onClick: ($event: any) => (_ctx.handleClickQuantityButton(item))
                            }, [
                              _createElementVNode("span", _hoisted_61, _toDisplayString(item.quantity), 1),
                              (item.material_unit)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(item.material_unit), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_60)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (item.images)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createVNode(_component_CarouselLoading, {
                            modelValue: item.images,
                            "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                            height: "160px"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]))
    ], 4)), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["hidden md:block w-full", { 'nested-table': !_ctx.isStandalone }])
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: (!_ctx.isStandalone ? _ctx.tableData : _ctx.data),
        height: _ctx.tableHeight,
        "row-key": "inventory_id",
        "show-header": _ctx.isStandalone
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "詳細",
            width: "80",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                class: "w-12",
                type: "info",
                style: {"background-color":"#b7b7b7"},
                text: "",
                bg: "",
                onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("span", null, "詳細", -1)
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          (!_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "blank",
                label: "",
                width: "100"
              }))
            : _createCommentVNode("", true),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                prop: "organization_name",
                label: "組織",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                prop: "department_name",
                label: "部署",
                width: "120"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSort('department_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('department_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'department_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('department_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                prop: "category_name",
                label: "カテゴリ",
                width: "100"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSort('category_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                prop: "material_name",
                label: "アイテム名"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSort('material_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('material_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'material_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('material_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "storage_date",
            label: "保管日",
            width: "200"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSort('storage_date')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('storage_date')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'storage_date' }])
                    }, _toDisplayString(_ctx.getSortIcon('storage_date')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              (!_ctx.isStandalone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_64, "保管日: "))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.storage_date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "expiration_date",
            label: "有効期限",
            width: "200"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSort('expiration_date')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('expiration_date')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'expiration_date' }])
                    }, _toDisplayString(_ctx.getSortIcon('expiration_date')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass({ 'text-red-500': _ctx.isExpired(scope.row.expiration_date) })
              }, [
                (!_ctx.isStandalone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "有効期限: "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.expiration_date)), 1)
              ], 2)
            ]),
            _: 1
          }),
          (!_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                prop: "blank",
                label: ""
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "quantity",
            label: "在庫数",
            width: "100",
            "header-align": "center",
            align: "right"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSort('quantity')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('quantity')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'quantity' }])
                    }, _toDisplayString(_ctx.getSortIcon('quantity')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.quantity), 1),
              (scope.row.material_unit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(scope.row.material_unit), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "",
            label: "画像",
            width: "150",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_row, { align: "middle" }, {
                default: _withCtx(() => [
                  (scope.row.images)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getImgUrls(scope.row.images), (image) => {
                        return (_openBlock(), _createBlock(_component_ImgLoading, {
                          key: image,
                          "model-value": image,
                          class: "thumbnail mr-1"
                        }, null, 8, ["model-value"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "",
            label: "アラート状況",
            width: "110",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_AlertStatusIndicators, {
                item: scope.row
              }, null, 8, ["item"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "アラート",
            width: "52",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: "material-symbols-outlined cursor-pointer mt-2",
                onClick: ($event: any) => (_ctx.handleAlarmButton(scope.row))
              }, " alarm ", 8, _hoisted_67)
            ]),
            _: 1
          }),
          (_ctx.isAuthForTransfer.valueOf())
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                label: "払い出し",
                width: "52",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: "material-symbols-outlined cursor-pointer mt-2",
                    onClick: ($event: any) => (_ctx.handleTransferInventoryButton(scope.row))
                  }, " trolley ", 8, _hoisted_68)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "削除",
            width: "52",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: "material-symbols-outlined cursor-pointer mt-2",
                onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
              }, " delete ", 8, _hoisted_69)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "height", "show-header"])), [
        [_directive_loading, _ctx.loading]
      ])
    ], 2),
    (!_ctx.isStandalone && _ctx.data.length > _ctx.INVENTORY_CONSTANTS.DETAIL_LEVEL.PAGE_SIZE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            (_ctx.data.length > _ctx.INVENTORY_CONSTANTS.DETAIL_LEVEL.EXCEED_RANGE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createVNode(_component_el_icon, {
                    color: "#E6A23C",
                    size: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WarnTriangleFilled)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, "在庫の検索結果が" + _toDisplayString(_ctx.INVENTORY_CONSTANTS.DETAIL_LEVEL.EXCEED_RANGE) + "件を超えています。", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, "在庫総計 " + _toDisplayString(_ctx.data.length) + " 件", 1),
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.itemCurrentPage,
                "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemCurrentPage) = $event)),
                "page-size": _ctx.itemPageSize,
                "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemPageSize) = $event)),
                layout: "prev, pager, next",
                total: _ctx.data.length,
                onSizeChange: _ctx.handleItemSizeChange,
                onCurrentChange: _ctx.handleItemCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_el_pagination, {
                "page-size": _ctx.itemPageSize,
                "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.itemPageSize) = $event)),
                layout: "prev, pager, next",
                total: _ctx.data.length,
                onCurrentChange: _ctx.handleItemCurrentChange
              }, null, 8, ["page-size", "total", "onCurrentChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_QuantityEditDrawer, {
      modelValue: _ctx.quantityDrawerVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.quantityDrawerVisible) = $event)),
      quantity: _ctx.editingItem?.quantity || 0,
      onConfirm: _ctx.handleQuantityConfirm,
      onCancel: _ctx.handleQuantityCancel
    }, null, 8, ["modelValue", "quantity", "onConfirm", "onCancel"])
  ], 64))
}